/**
 * Converts a decimal number to a percentage string representation.
 *
 * @param {number} decimal - The decimal number to be converted to a percentage.
 * @param {Intl.LocalesArgument} [locales="de-DE"] - Optional locales argument for formatting.
 * @param {Intl.NumberFormatOptions} [options] - Optional number format options.
 * @returns {string} A string representing the percentage, formatted according to the provided options.
 */
const toPercentage = (
  decimal: number,
  locales: Intl.LocalesArgument = 'de-DE',
  options: Intl.NumberFormatOptions = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  }
): string => {
  // Multiply the decimal by 100 and format it as a percentage using toLocaleString
  return (decimal * 100).toLocaleString(locales, options);
};

export { toPercentage };
